import { Model } from "@vuex-orm/core";
import Batch from "./Batch";
import RawMaterial from "./RawMaterial";
import { required, maxLength, integer } from "vuelidate/lib/validators";
import { BatchTicketAttachment, RawTicketAttachment } from "./Attachment";

export class BatchTicket extends Model {
  static entity = "batchtickets";

  static $fetchActive() {
    return this.api().get('BatchTickets/?archived=false')
  }
  static $fetchAll() {
    return this.api().get('BatchTickets/')
  }
  static $get (id) {
    return this.api().get(`BatchTickets/${id}/`)
  }
  static $post (data) {
    return this.api().post(`BatchTickets/`, data)
  }
  static $put (id, data) {
    return this.api().put(`BatchTickets/${id}/`, data)
  }
  static $patch (id, data) {
    return this.api().patch(`BatchTickets/${id}/`, data)
  }

  static fields() {
    return {
      id: this.attr(null),
      batches: this.hasManyBy(Batch, "batch_ids"),
      batch_ids: this.attr(null),
      attachments: this.hasMany(BatchTicketAttachment, "batchticket_id"),
      rush: this.boolean(false),
      rushIcon: this.string("mdi-clock-fast"),
      notes: this.string(""),
      notesIcon: this.string("mdi-message-bulleted"),
      name: this.string("My Default Ticket"),
      nameCounter: this.number(48),
      nameIcon: this.string("mdi-tag"),
      samples: this.number(1),
      samplesIcon: this.string("mdi-test-tube"),
      archived: this.boolean(false),
      stateIcon: this.string("fas fa-spinner"),
      created_on: this.string(""),
      lastmodified: this.string(new Date(), value =>
        new Date(value).toLocaleString()
      )
    };
  }
  toCreatePayload() {
    return {
      name: this.name,
      rush: this.rush,
      notes: this.notes,
      samples: this.samples,
      batches: this.batch_ids,
      archived: this.archived
    };
  }
  toUpdatePayload() {
    return {
      id: this.$id,
      ...this.toCreatePayload()
    };
  }
  static get validations() {
    return {
      formdata: {
        name: { required, maxLength: maxLength(48) },
        samples: { required, integer },
        batch_ids: { required }
      }
    };
  }
}


export class RawTicket extends Model {
  static entity = "rawtickets";

  static $fetchActive() {
    return this.api().get('RawTickets/?archived=false')
  }
  static $fetchAll() {
    return this.api().get('RawTickets/')
  }
  static $get (id) {
    return this.api().get(`RawTickets/${id}/`)
  }
  static $post (data) {
    return this.api().post(`RawTickets/`, data)
  }
  static $put (id, data) {
    return this.api().put(`RawTickets/${id}/`, data)
  }
  static $patch (id, data) {
    return this.api().patch(`RawTickets/${id}/`, data)
  }

  static fields() {
    return {
      ...super.fields(),
      id: this.attr(null),
      rawmaterials: this.hasManyBy(RawMaterial, "rawmaterial_ids"),
      rawmaterial_ids: this.attr(null),
      attachments: this.hasMany(RawTicketAttachment, "rawticket_id"),
      rush: this.boolean(false),
      rushIcon: this.string("mdi-clock-fast"),
      notes: this.string(""),
      notesIcon: this.string("mdi-message-bulleted"),
      name: this.string("My Default Ticket"),
      nameCounter: this.number(48),
      nameIcon: this.string("mdi-tag"),
      samples: this.number(1),
      samplesIcon: this.string("mdi-test-tube"),
      archived: this.boolean(false),
      stateIcon: this.string("fas fa-spinner"),
      created_on: this.string(""),
      lastmodified: this.string(new Date(), value =>
        new Date(value).toLocaleString()
      )
    };
  }
  toCreatePayload() {
    return {
      name: this.name,
      rush: this.rush,
      notes: this.notes,
      samples: this.samples,
      archived: this.archived,
      rawmaterials: this.rawmaterial_ids
    };
  }
  toUpdatePayload() {
    return {
      id: this.$id,
      ...this.toCreatePayload()
    };
  }
  static get validations() {
    return {
      formdata: {
        name: { required, maxLength: maxLength(48) },
        samples: { required, integer },
        rawmaterial_ids: { required }
      }
    };
  }
}

